import React from 'react';

import { BrancheDto } from 'lib_api/lib/api/gen';

import TableWithoutPaginationAndSort from 'components/WrappedComponents/Table/TableWithoutPaginationAndSort';
import { ColumnProps } from 'components/WrappedComponents/Table/types';

import { useReferentielDashboardUnpagedSearch } from '../utils';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import CellDetailsAndActions from './CellDetailsAndActions';
import { useFetchBranches } from './utils';

function buildDetailsContent(
  data: BrancheDto,
  refreshDashboard: () => void,
): React.ReactElement {
  return (
    <CellDetailsAndActions branche={data} refreshDashboard={refreshDashboard} />
  );
}

function DashboardBranche(): React.ReactElement {
  const { fetchData, filter, setFilter, refreshDashboard } =
    useReferentielDashboardUnpagedSearch(useFetchBranches, {});

  function buildColumns(): ColumnProps<BrancheDto>[] {
    return [
      {
        title: 'Nature',
        buildCellContent: data => data.nature,
      },
      {
        title: 'Branche',
        buildCellContent: data => data.branche,
      },
      {
        title: '',
        buildCellContent: data => buildDetailsContent(data, refreshDashboard),
      },
    ];
  }

  return (
    <div className="table-container">
      <TableWithoutPaginationAndSort
        columns={buildColumns()}
        fetchData={fetchData}
        header={fetchedData => (
          <DashboardHeader
            totalCount={fetchedData?.total || 0}
            refreshDashboard={refreshDashboard}
          />
        )}
        buildItemKey={(item): string => item.id}
        filter={filter}
        setFilter={setFilter}
      />
    </div>
  );
}

export default DashboardBranche;
